function onVisibilityChange(){
    document.querySelectorAll('.animation-wrapper').forEach((item) => {
        var visible = isPartialElementInViewport(item);
        if(visible){
            item.querySelectorAll('.animation-element').forEach((el) => {
                if(document.body.getAttribute('data-loaded') === 'true'){
                    setTimeout(() => {
                        el.classList.add('in-view');
                    }, 1000);
                }else{
                    setTimeout(() => {
                        el.classList.add('in-view');
                    }, 1500);
                }
            })
        }
    });
}

// Non-jQuery
if (window.addEventListener) {

    document.addEventListener('DOMContentLoaded', onVisibilityChange, false);
    document.addEventListener('load', onVisibilityChange, false);
    document.addEventListener('scroll', onVisibilityChange, false);
    document.addEventListener('resize', onVisibilityChange, false);

    if(document.querySelectorAll('.parallax-wrapper').length > 0){
        document.addEventListener('DOMContentLoaded', parallaxEffect, false);
        document.addEventListener('load', parallaxEffect, false);
        document.addEventListener('scroll', parallaxEffect, false);
        document.addEventListener('resize', parallaxEffect, false);
    }

    document.addEventListener('DOMContentLoaded', adjustMainMinHeight);

} else if (window.attachEvent)  {

    attachEvent('onDOMContentLoaded', onVisibilityChange); // Internet Explorer 9+ :(
    attachEvent('onload', onVisibilityChange);
    attachEvent('onscroll', onVisibilityChange);
    attachEvent('onresize', onVisibilityChange);

    if(document.querySelectorAll('.parallax-wrapper').length > 0){
        attachEvent('DOMContentLoaded', parallaxEffect);
        attachEvent('load', parallaxEffect);
        attachEvent('scroll', parallaxEffect);
        attachEvent('resize', parallaxEffect);
    }

    attachEvent('onDOMContentLoaded', adjustMainMinHeight)

}

function adjustMainMinHeight(){
    var footer = document.querySelector('custom-footer');

    if(footer){
        var footerHeight = footer.offsetHeight;
        document.querySelector('#main').style.minHeight = `calc(100vh - ${ footerHeight }px)`;
    }
}

function parallaxEffect(){
    document.querySelectorAll('.parallax-wrapper').forEach((item) => {

        var rect = item.getBoundingClientRect();
        if(rect.top <= (window.innerHeight || document.documentElement.clientHeight) && rect.bottom >= 0){
            var pos = rect.top / (rect.bottom - rect.top) + 1;
            item.querySelectorAll('.parallax-element').forEach((elem) => {
                elem.style.transform = `translateY(-${pos * 10}%)`
            })
        }

    })
}

function isElementInViewport (el) {
    var rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
    );
}

function isPartialElementInViewport (el) {
    var rect = el.getBoundingClientRect();

    return (
        rect.top <= (window.innerHeight || document.documentElement.clientHeight) ||
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    );
}

function fetchConfig(type = 'json'){
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
}

function arraysEqual(a1,a2) {
    /* WARNING: arrays must not contain {objects} or behavior may be undefined */
    return JSON.stringify(a1)==JSON.stringify(a2);
}

if(!customElements.get('custom-accordion')){
    class CustomAccordion extends HTMLElement {
        constructor(){
            super();
    
            this.init();
        }
    
        init(){
            this.text = this.querySelector('.accordion-text');
            this.textInner = this.text.querySelector('.accordion-text__inner');
            this.remainOpen = this.getAttribute('data-remain-open') == 'true'? true : false;
    
            var ifOpened = this.getAttribute('data-open') == 'true'? true : false;
            if(ifOpened){
                this.textHeight = this.textInner.clientHeight;
                this.text.style.height = `calc(${this.textHeight}px + 2rem)`;
            }else{
                this.textHeight = 0;
                this.text.style.height = `${this.textHeight}px`;
            }
    
            this.addEventListener('click', this.openAccordion.bind(this));
            this.addEventListener('keydown', e => {
                // check if checkbox clicked
                if(e.target.classList.contains('checkbox')) return;

                if(e.key === 'Enter'){
                    this.openAccordion(e);
                }
            })
        }
    
        openAccordion(e){
            var ifOpened = this.getAttribute('data-open') == 'true'? true : false;
            if(ifOpened && (!this.remainOpen || e.target.classList.contains('accordion-heading') || e.target.closest('.accordion-heading'))){ 
                // close the accordion
                this.setAttribute('data-open', 'false');
                this.setAccordionTextHeight();

                this.querySelectorAll('input').forEach(item => {
                    item.setAttribute('tabindex', '-1');
                })
            }else{
                // open accordion
                this.setAttribute('data-open', 'true');
                this.setAccordionTextHeight(true);

                this.querySelectorAll('input').forEach(item => {
                    item.setAttribute('tabindex', '0');
                })
            }
        }
    
        closeAccordion(){
            this.setAttribute('data-open', 'false');
            this.setAccordionTextHeight();

            this.querySelectorAll('input').forEach(item => {
                item.setAttribute('tabindex', '-1');
            })
        }
    
        setAccordionTextHeight(open = false){
            if(open){
                this.textHeight = this.textInner.clientHeight;
                this.text.style.height = `calc(${this.textHeight}px + 2rem)`;
                return;
            }
    
            this.textHeight = 0;
            this.text.style.height = `${this.textHeight}px`;
        }
    }
    
    customElements.define('custom-accordion', CustomAccordion);    
}

if(!customElements.get('quantity-selector')){
    class QuantitySelector extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.btnRemoveQuantity = this.querySelector('[data-action="remove"]');
            this.btnAddQuantity = this.querySelector('[data-action="add"]');

            this.input = this.querySelector('.input-quantity');

            this.btnAddQuantity.addEventListener('click', this.addQuantity.bind(this));
            this.btnAddQuantity.addEventListener('keydown', e => {
                if(e.key === 'Enter'){
                    this.addQuantity(e);
                }
            })
            this.btnRemoveQuantity.addEventListener('click', this.removeQuantity.bind(this));
            this.btnRemoveQuantity.addEventListener('keydown', e => {
                if(e.key === 'Enter'){
                    this.removeQuantity(e);
                }
            })

            this.input.addEventListener('input', (e) => {
                this.updateProductForm(this.input.value);
            })
        }

        addQuantity(){
            if(this.input.value.trim() == "" || parseInt(this.input.value) < 0){
                this.setQuantity(1);
                return;
            }

            this.setQuantity(parseInt(this.input.value) + 1);
        }

        removeQuantity(){
            if(this.input.value.trim() == "" || parseInt(this.input.value) < 0){
                this.setQuantity(1);
                return;
            }

            this.setQuantity(parseInt(this.input.value) - 1 > 0? parseInt(this.input.value) - 1 : 1);
        }

        setQuantity(value){
            this.input.value = value;
            this.input.setAttribute('value', value);

            this.updateProductForm(value);
        }

        updateProductForm(value){
            if(this.closest('custom-featured-product, custom-product-details')){
                var wrapper = this.closest('custom-featured-product, custom-product-details');
                var productForm = wrapper.querySelector('#product-form');
                if(!productForm || this.input.form === productForm) return;

                var quantityInput = productForm.querySelector('input[name="quantity"]');
                if(quantityInput){
                    quantityInput.value = value;
                    quantityInput.setAttribute('value', value);
                }
            }
        }
    }

    customElements.define('quantity-selector', QuantitySelector);
}
